<script>
    import CN from "classnames";

    export let absolute = false;

    const className = CN("gw-preview-badge", {
        "gw-preview-badge-absolute": absolute,
    });

    export { className as class };
</script>

<div class={className}>
    <span class="gw-preview-badge__circle" />
    <span class="gw-preview-badge__text">Dummy content shown</span>
</div>

<style lang="postcss">
    .gw-preview-badge {
        background-color: #e0f0ff;
        color: #00527c;
        width: fit-content;
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.25rem 1rem;
        border-radius: 9999px;
        font-size: 12px;
        font-style: normal;
        font-weight: 550;
        line-height: inherit;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
        backdrop-filter: blur(2px);
        z-index: 20;
        pointer-events: none;
        user-select: none;
        white-space: nowrap;

        &__circle {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background-color: #0094d5;
        }
    }

    .gw-preview-badge.gw-preview-badge-absolute {
        position: absolute;
        top: 2px;
        right: 0;
    }
</style>
